// src/data/countries.js
// Single source of truth for country data used by every CountrySelect.
// ISO 3166-1 alpha-2 codes with international dialing codes (E.164 country codes).
// Sorted by English name.

export const COUNTRIES = [
  { code: "AF", iso: "AF", name: "Afghanistan", dialCode: "+93", dial: "+93" },
  { code: "AX", iso: "AX", name: "Åland Islands", dialCode: "+358", dial: "+358" },
  { code: "AL", iso: "AL", name: "Albania", dialCode: "+355", dial: "+355" },
  { code: "DZ", iso: "DZ", name: "Algeria", dialCode: "+213", dial: "+213" },
  { code: "AS", iso: "AS", name: "American Samoa", dialCode: "+1", dial: "+1" },
  { code: "AD", iso: "AD", name: "Andorra", dialCode: "+376", dial: "+376" },
  { code: "AO", iso: "AO", name: "Angola", dialCode: "+244", dial: "+244" },
  { code: "AI", iso: "AI", name: "Anguilla", dialCode: "+1", dial: "+1" },
  { code: "AQ", iso: "AQ", name: "Antarctica", dialCode: "+672", dial: "+672" },
  { code: "AG", iso: "AG", name: "Antigua and Barbuda", dialCode: "+1", dial: "+1" },
  { code: "AR", iso: "AR", name: "Argentina", dialCode: "+54", dial: "+54" },
  { code: "AM", iso: "AM", name: "Armenia", dialCode: "+374", dial: "+374" },
  { code: "AW", iso: "AW", name: "Aruba", dialCode: "+297", dial: "+297" },
  { code: "AU", iso: "AU", name: "Australia", dialCode: "+61", dial: "+61" },
  { code: "AT", iso: "AT", name: "Austria", dialCode: "+43", dial: "+43" },
  { code: "AZ", iso: "AZ", name: "Azerbaijan", dialCode: "+994", dial: "+994" },
  { code: "BS", iso: "BS", name: "Bahamas", dialCode: "+1", dial: "+1" },
  { code: "BH", iso: "BH", name: "Bahrain", dialCode: "+973", dial: "+973" },
  { code: "BD", iso: "BD", name: "Bangladesh", dialCode: "+880", dial: "+880" },
  { code: "BB", iso: "BB", name: "Barbados", dialCode: "+1", dial: "+1" },
  { code: "BY", iso: "BY", name: "Belarus", dialCode: "+375", dial: "+375" },
  { code: "BE", iso: "BE", name: "Belgium", dialCode: "+32", dial: "+32" },
  { code: "BZ", iso: "BZ", name: "Belize", dialCode: "+501", dial: "+501" },
  { code: "BJ", iso: "BJ", name: "Benin", dialCode: "+229", dial: "+229" },
  { code: "BM", iso: "BM", name: "Bermuda", dialCode: "+1", dial: "+1" },
  { code: "BT", iso: "BT", name: "Bhutan", dialCode: "+975", dial: "+975" },
  { code: "BO", iso: "BO", name: "Bolivia", dialCode: "+591", dial: "+591" },
  { code: "BQ", iso: "BQ", name: "Bonaire, Sint Eustatius and Saba", dialCode: "+599", dial: "+599" },
  { code: "BA", iso: "BA", name: "Bosnia and Herzegovina", dialCode: "+387", dial: "+387" },
  { code: "BW", iso: "BW", name: "Botswana", dialCode: "+267", dial: "+267" },
  { code: "BV", iso: "BV", name: "Bouvet Island", dialCode: "+47", dial: "+47" },
  { code: "BR", iso: "BR", name: "Brazil", dialCode: "+55", dial: "+55" },
  { code: "IO", iso: "IO", name: "British Indian Ocean Territory", dialCode: "+246", dial: "+246" },
  { code: "VG", iso: "VG", name: "British Virgin Islands", dialCode: "+1", dial: "+1" },
  { code: "BN", iso: "BN", name: "Brunei", dialCode: "+673", dial: "+673" },
  { code: "BG", iso: "BG", name: "Bulgaria", dialCode: "+359", dial: "+359" },
  { code: "BF", iso: "BF", name: "Burkina Faso", dialCode: "+226", dial: "+226" },
  { code: "BI", iso: "BI", name: "Burundi", dialCode: "+257", dial: "+257" },
  { code: "KH", iso: "KH", name: "Cambodia", dialCode: "+855", dial: "+855" },
  { code: "CM", iso: "CM", name: "Cameroon", dialCode: "+237", dial: "+237" },
  { code: "CA", iso: "CA", name: "Canada", dialCode: "+1", dial: "+1" },
  { code: "CV", iso: "CV", name: "Cape Verde", dialCode: "+238", dial: "+238" },
  { code: "KY", iso: "KY", name: "Cayman Islands", dialCode: "+1", dial: "+1" },
  { code: "CF", iso: "CF", name: "Central African Republic", dialCode: "+236", dial: "+236" },
  { code: "TD", iso: "TD", name: "Chad", dialCode: "+235", dial: "+235" },
  { code: "CL", iso: "CL", name: "Chile", dialCode: "+56", dial: "+56" },
  { code: "CN", iso: "CN", name: "China", dialCode: "+86", dial: "+86" },
  { code: "CX", iso: "CX", name: "Christmas Island", dialCode: "+61", dial: "+61" },
  { code: "CC", iso: "CC", name: "Cocos (Keeling) Islands", dialCode: "+61", dial: "+61" },
  { code: "CO", iso: "CO", name: "Colombia", dialCode: "+57", dial: "+57" },
  { code: "KM", iso: "KM", name: "Comoros", dialCode: "+269", dial: "+269" },
  { code: "CG", iso: "CG", name: "Congo", dialCode: "+242", dial: "+242" },
  { code: "CD", iso: "CD", name: "Congo (Democratic Republic)", dialCode: "+243", dial: "+243" },
  { code: "CK", iso: "CK", name: "Cook Islands", dialCode: "+682", dial: "+682" },
  { code: "CR", iso: "CR", name: "Costa Rica", dialCode: "+506", dial: "+506" },
  { code: "CI", iso: "CI", name: "Côte d'Ivoire", dialCode: "+225", dial: "+225" },
  { code: "HR", iso: "HR", name: "Croatia", dialCode: "+385", dial: "+385" },
  { code: "CU", iso: "CU", name: "Cuba", dialCode: "+53", dial: "+53" },
  { code: "CW", iso: "CW", name: "Curaçao", dialCode: "+599", dial: "+599" },
  { code: "CY", iso: "CY", name: "Cyprus", dialCode: "+357", dial: "+357" },
  { code: "CZ", iso: "CZ", name: "Czechia", dialCode: "+420", dial: "+420" },
  { code: "DK", iso: "DK", name: "Denmark", dialCode: "+45", dial: "+45" },
  { code: "DJ", iso: "DJ", name: "Djibouti", dialCode: "+253", dial: "+253" },
  { code: "DM", iso: "DM", name: "Dominica", dialCode: "+1", dial: "+1" },
  { code: "DO", iso: "DO", name: "Dominican Republic", dialCode: "+1", dial: "+1" },
  { code: "EC", iso: "EC", name: "Ecuador", dialCode: "+593", dial: "+593" },
  { code: "EG", iso: "EG", name: "Egypt", dialCode: "+20", dial: "+20" },
  { code: "SV", iso: "SV", name: "El Salvador", dialCode: "+503", dial: "+503" },
  { code: "GQ", iso: "GQ", name: "Equatorial Guinea", dialCode: "+240", dial: "+240" },
  { code: "ER", iso: "ER", name: "Eritrea", dialCode: "+291", dial: "+291" },
  { code: "EE", iso: "EE", name: "Estonia", dialCode: "+372", dial: "+372" },
  { code: "SZ", iso: "SZ", name: "Eswatini", dialCode: "+268", dial: "+268" },
  { code: "ET", iso: "ET", name: "Ethiopia", dialCode: "+251", dial: "+251" },
  { code: "FK", iso: "FK", name: "Falkland Islands", dialCode: "+500", dial: "+500" },
  { code: "FO", iso: "FO", name: "Faroe Islands", dialCode: "+298", dial: "+298" },
  { code: "FJ", iso: "FJ", name: "Fiji", dialCode: "+679", dial: "+679" },
  { code: "FI", iso: "FI", name: "Finland", dialCode: "+358", dial: "+358" },
  { code: "FR", iso: "FR", name: "France", dialCode: "+33", dial: "+33" },
  { code: "GF", iso: "GF", name: "French Guiana", dialCode: "+594", dial: "+594" },
  { code: "PF", iso: "PF", name: "French Polynesia", dialCode: "+689", dial: "+689" },
  { code: "TF", iso: "TF", name: "French Southern Territories", dialCode: "+262", dial: "+262" },
  { code: "GA", iso: "GA", name: "Gabon", dialCode: "+241", dial: "+241" },
  { code: "GM", iso: "GM", name: "Gambia", dialCode: "+220", dial: "+220" },
  { code: "GE", iso: "GE", name: "Georgia", dialCode: "+995", dial: "+995" },
  { code: "DE", iso: "DE", name: "Germany", dialCode: "+49", dial: "+49" },
  { code: "GH", iso: "GH", name: "Ghana", dialCode: "+233", dial: "+233" },
  { code: "GI", iso: "GI", name: "Gibraltar", dialCode: "+350", dial: "+350" },
  { code: "GR", iso: "GR", name: "Greece", dialCode: "+30", dial: "+30" },
  { code: "GL", iso: "GL", name: "Greenland", dialCode: "+299", dial: "+299" },
  { code: "GD", iso: "GD", name: "Grenada", dialCode: "+1", dial: "+1" },
  { code: "GP", iso: "GP", name: "Guadeloupe", dialCode: "+590", dial: "+590" },
  { code: "GU", iso: "GU", name: "Guam", dialCode: "+1", dial: "+1" },
  { code: "GT", iso: "GT", name: "Guatemala", dialCode: "+502", dial: "+502" },
  { code: "GG", iso: "GG", name: "Guernsey", dialCode: "+44", dial: "+44" },
  { code: "GN", iso: "GN", name: "Guinea", dialCode: "+224", dial: "+224" },
  { code: "GW", iso: "GW", name: "Guinea-Bissau", dialCode: "+245", dial: "+245" },
  { code: "GY", iso: "GY", name: "Guyana", dialCode: "+592", dial: "+592" },
  { code: "HT", iso: "HT", name: "Haiti", dialCode: "+509", dial: "+509" },
  { code: "HM", iso: "HM", name: "Heard Island and McDonald Islands", dialCode: "+672", dial: "+672" },
  { code: "VA", iso: "VA", name: "Holy See (Vatican City)", dialCode: "+39", dial: "+39" },
  { code: "HN", iso: "HN", name: "Honduras", dialCode: "+504", dial: "+504" },
  { code: "HK", iso: "HK", name: "Hong Kong", dialCode: "+852", dial: "+852" },
  { code: "HU", iso: "HU", name: "Hungary", dialCode: "+36", dial: "+36" },
  { code: "IS", iso: "IS", name: "Iceland", dialCode: "+354", dial: "+354" },
  { code: "IN", iso: "IN", name: "India", dialCode: "+91", dial: "+91" },
  { code: "ID", iso: "ID", name: "Indonesia", dialCode: "+62", dial: "+62" },
  { code: "IR", iso: "IR", name: "Iran", dialCode: "+98", dial: "+98" },
  { code: "IQ", iso: "IQ", name: "Iraq", dialCode: "+964", dial: "+964" },
  { code: "IE", iso: "IE", name: "Ireland", dialCode: "+353", dial: "+353" },
  { code: "IM", iso: "IM", name: "Isle of Man", dialCode: "+44", dial: "+44" },
  { code: "IL", iso: "IL", name: "Israel", dialCode: "+972", dial: "+972" },
  { code: "IT", iso: "IT", name: "Italy", dialCode: "+39", dial: "+39" },
  { code: "JM", iso: "JM", name: "Jamaica", dialCode: "+1", dial: "+1" },
  { code: "JP", iso: "JP", name: "Japan", dialCode: "+81", dial: "+81" },
  { code: "JE", iso: "JE", name: "Jersey", dialCode: "+44", dial: "+44" },
  { code: "JO", iso: "JO", name: "Jordan", dialCode: "+962", dial: "+962" },
  { code: "KZ", iso: "KZ", name: "Kazakhstan", dialCode: "+7", dial: "+7" },
  { code: "KE", iso: "KE", name: "Kenya", dialCode: "+254", dial: "+254" },
  { code: "KI", iso: "KI", name: "Kiribati", dialCode: "+686", dial: "+686" },
  { code: "XK", iso: "XK", name: "Kosovo", dialCode: "+383", dial: "+383" },
  { code: "KW", iso: "KW", name: "Kuwait", dialCode: "+965", dial: "+965" },
  { code: "KG", iso: "KG", name: "Kyrgyzstan", dialCode: "+996", dial: "+996" },
  { code: "LA", iso: "LA", name: "Laos", dialCode: "+856", dial: "+856" },
  { code: "LV", iso: "LV", name: "Latvia", dialCode: "+371", dial: "+371" },
  { code: "LB", iso: "LB", name: "Lebanon", dialCode: "+961", dial: "+961" },
  { code: "LS", iso: "LS", name: "Lesotho", dialCode: "+266", dial: "+266" },
  { code: "LR", iso: "LR", name: "Liberia", dialCode: "+231", dial: "+231" },
  { code: "LY", iso: "LY", name: "Libya", dialCode: "+218", dial: "+218" },
  { code: "LI", iso: "LI", name: "Liechtenstein", dialCode: "+423", dial: "+423" },
  { code: "LT", iso: "LT", name: "Lithuania", dialCode: "+370", dial: "+370" },
  { code: "LU", iso: "LU", name: "Luxembourg", dialCode: "+352", dial: "+352" },
  { code: "MO", iso: "MO", name: "Macao", dialCode: "+853", dial: "+853" },
  { code: "MG", iso: "MG", name: "Madagascar", dialCode: "+261", dial: "+261" },
  { code: "MW", iso: "MW", name: "Malawi", dialCode: "+265", dial: "+265" },
  { code: "MY", iso: "MY", name: "Malaysia", dialCode: "+60", dial: "+60" },
  { code: "MV", iso: "MV", name: "Maldives", dialCode: "+960", dial: "+960" },
  { code: "ML", iso: "ML", name: "Mali", dialCode: "+223", dial: "+223" },
  { code: "MT", iso: "MT", name: "Malta", dialCode: "+356", dial: "+356" },
  { code: "MH", iso: "MH", name: "Marshall Islands", dialCode: "+692", dial: "+692" },
  { code: "MQ", iso: "MQ", name: "Martinique", dialCode: "+596", dial: "+596" },
  { code: "MR", iso: "MR", name: "Mauritania", dialCode: "+222", dial: "+222" },
  { code: "MU", iso: "MU", name: "Mauritius", dialCode: "+230", dial: "+230" },
  { code: "YT", iso: "YT", name: "Mayotte", dialCode: "+262", dial: "+262" },
  { code: "MX", iso: "MX", name: "Mexico", dialCode: "+52", dial: "+52" },
  { code: "FM", iso: "FM", name: "Micronesia", dialCode: "+691", dial: "+691" },
  { code: "MD", iso: "MD", name: "Moldova", dialCode: "+373", dial: "+373" },
  { code: "MC", iso: "MC", name: "Monaco", dialCode: "+377", dial: "+377" },
  { code: "MN", iso: "MN", name: "Mongolia", dialCode: "+976", dial: "+976" },
  { code: "ME", iso: "ME", name: "Montenegro", dialCode: "+382", dial: "+382" },
  { code: "MS", iso: "MS", name: "Montserrat", dialCode: "+1", dial: "+1" },
  { code: "MA", iso: "MA", name: "Morocco", dialCode: "+212", dial: "+212" },
  { code: "MZ", iso: "MZ", name: "Mozambique", dialCode: "+258", dial: "+258" },
  { code: "MM", iso: "MM", name: "Myanmar", dialCode: "+95", dial: "+95" },
  { code: "NA", iso: "NA", name: "Namibia", dialCode: "+264", dial: "+264" },
  { code: "NR", iso: "NR", name: "Nauru", dialCode: "+674", dial: "+674" },
  { code: "NP", iso: "NP", name: "Nepal", dialCode: "+977", dial: "+977" },
  { code: "NL", iso: "NL", name: "Netherlands", dialCode: "+31", dial: "+31" },
  { code: "NC", iso: "NC", name: "New Caledonia", dialCode: "+687", dial: "+687" },
  { code: "NZ", iso: "NZ", name: "New Zealand", dialCode: "+64", dial: "+64" },
  { code: "NI", iso: "NI", name: "Nicaragua", dialCode: "+505", dial: "+505" },
  { code: "NE", iso: "NE", name: "Niger", dialCode: "+227", dial: "+227" },
  { code: "NG", iso: "NG", name: "Nigeria", dialCode: "+234", dial: "+234" },
  { code: "NU", iso: "NU", name: "Niue", dialCode: "+683", dial: "+683" },
  { code: "NF", iso: "NF", name: "Norfolk Island", dialCode: "+672", dial: "+672" },
  { code: "KP", iso: "KP", name: "North Korea", dialCode: "+850", dial: "+850" },
  { code: "MK", iso: "MK", name: "North Macedonia", dialCode: "+389", dial: "+389" },
  { code: "MP", iso: "MP", name: "Northern Mariana Islands", dialCode: "+1", dial: "+1" },
  { code: "NO", iso: "NO", name: "Norway", dialCode: "+47", dial: "+47" },
  { code: "OM", iso: "OM", name: "Oman", dialCode: "+968", dial: "+968" },
  { code: "PK", iso: "PK", name: "Pakistan", dialCode: "+92", dial: "+92" },
  { code: "PW", iso: "PW", name: "Palau", dialCode: "+680", dial: "+680" },
  { code: "PS", iso: "PS", name: "Palestine", dialCode: "+970", dial: "+970" },
  { code: "PA", iso: "PA", name: "Panama", dialCode: "+507", dial: "+507" },
  { code: "PG", iso: "PG", name: "Papua New Guinea", dialCode: "+675", dial: "+675" },
  { code: "PY", iso: "PY", name: "Paraguay", dialCode: "+595", dial: "+595" },
  { code: "PE", iso: "PE", name: "Peru", dialCode: "+51", dial: "+51" },
  { code: "PH", iso: "PH", name: "Philippines", dialCode: "+63", dial: "+63" },
  { code: "PN", iso: "PN", name: "Pitcairn", dialCode: "+64", dial: "+64" },
  { code: "PL", iso: "PL", name: "Poland", dialCode: "+48", dial: "+48" },
  { code: "PT", iso: "PT", name: "Portugal", dialCode: "+351", dial: "+351" },
  { code: "PR", iso: "PR", name: "Puerto Rico", dialCode: "+1", dial: "+1" },
  { code: "QA", iso: "QA", name: "Qatar", dialCode: "+974", dial: "+974" },
  { code: "RE", iso: "RE", name: "Réunion", dialCode: "+262", dial: "+262" },
  { code: "RO", iso: "RO", name: "Romania", dialCode: "+40", dial: "+40" },
  { code: "RU", iso: "RU", name: "Russia", dialCode: "+7", dial: "+7" },
  { code: "RW", iso: "RW", name: "Rwanda", dialCode: "+250", dial: "+250" },
  { code: "BL", iso: "BL", name: "Saint Barthélemy", dialCode: "+590", dial: "+590" },
  { code: "SH", iso: "SH", name: "Saint Helena", dialCode: "+290", dial: "+290" },
  { code: "KN", iso: "KN", name: "Saint Kitts and Nevis", dialCode: "+1", dial: "+1" },
  { code: "LC", iso: "LC", name: "Saint Lucia", dialCode: "+1", dial: "+1" },
  { code: "MF", iso: "MF", name: "Saint Martin (French part)", dialCode: "+590", dial: "+590" },
  { code: "PM", iso: "PM", name: "Saint Pierre and Miquelon", dialCode: "+508", dial: "+508" },
  { code: "VC", iso: "VC", name: "Saint Vincent and the Grenadines", dialCode: "+1", dial: "+1" },
  { code: "WS", iso: "WS", name: "Samoa", dialCode: "+685", dial: "+685" },
  { code: "SM", iso: "SM", name: "San Marino", dialCode: "+378", dial: "+378" },
  { code: "ST", iso: "ST", name: "São Tomé and Príncipe", dialCode: "+239", dial: "+239" },
  { code: "SA", iso: "SA", name: "Saudi Arabia", dialCode: "+966", dial: "+966" },
  { code: "SN", iso: "SN", name: "Senegal", dialCode: "+221", dial: "+221" },
  { code: "RS", iso: "RS", name: "Serbia", dialCode: "+381", dial: "+381" },
  { code: "SC", iso: "SC", name: "Seychelles", dialCode: "+248", dial: "+248" },
  { code: "SL", iso: "SL", name: "Sierra Leone", dialCode: "+232", dial: "+232" },
  { code: "SG", iso: "SG", name: "Singapore", dialCode: "+65", dial: "+65" },
  { code: "SX", iso: "SX", name: "Sint Maarten (Dutch part)", dialCode: "+1", dial: "+1" },
  { code: "SK", iso: "SK", name: "Slovakia", dialCode: "+421", dial: "+421" },
  { code: "SI", iso: "SI", name: "Slovenia", dialCode: "+386", dial: "+386" },
  { code: "SB", iso: "SB", name: "Solomon Islands", dialCode: "+677", dial: "+677" },
  { code: "SO", iso: "SO", name: "Somalia", dialCode: "+252", dial: "+252" },
  { code: "ZA", iso: "ZA", name: "South Africa", dialCode: "+27", dial: "+27" },
  { code: "GS", iso: "GS", name: "South Georgia and the South Sandwich Islands", dialCode: "+500", dial: "+500" },
  { code: "KR", iso: "KR", name: "South Korea", dialCode: "+82", dial: "+82" },
  { code: "SS", iso: "SS", name: "South Sudan", dialCode: "+211", dial: "+211" },
  { code: "ES", iso: "ES", name: "Spain", dialCode: "+34", dial: "+34" },
  { code: "LK", iso: "LK", name: "Sri Lanka", dialCode: "+94", dial: "+94" },
  { code: "SD", iso: "SD", name: "Sudan", dialCode: "+249", dial: "+249" },
  { code: "SR", iso: "SR", name: "Suriname", dialCode: "+597", dial: "+597" },
  { code: "SJ", iso: "SJ", name: "Svalbard and Jan Mayen", dialCode: "+47", dial: "+47" },
  { code: "SE", iso: "SE", name: "Sweden", dialCode: "+46", dial: "+46" },
  { code: "CH", iso: "CH", name: "Switzerland", dialCode: "+41", dial: "+41" },
  { code: "SY", iso: "SY", name: "Syria", dialCode: "+963", dial: "+963" },
  { code: "TW", iso: "TW", name: "Taiwan", dialCode: "+886", dial: "+886" },
  { code: "TJ", iso: "TJ", name: "Tajikistan", dialCode: "+992", dial: "+992" },
  { code: "TZ", iso: "TZ", name: "Tanzania", dialCode: "+255", dial: "+255" },
  { code: "TH", iso: "TH", name: "Thailand", dialCode: "+66", dial: "+66" },
  { code: "TL", iso: "TL", name: "Timor-Leste", dialCode: "+670", dial: "+670" },
  { code: "TG", iso: "TG", name: "Togo", dialCode: "+228", dial: "+228" },
  { code: "TK", iso: "TK", name: "Tokelau", dialCode: "+690", dial: "+690" },
  { code: "TO", iso: "TO", name: "Tonga", dialCode: "+676", dial: "+676" },
  { code: "TT", iso: "TT", name: "Trinidad and Tobago", dialCode: "+1", dial: "+1" },
  { code: "TN", iso: "TN", name: "Tunisia", dialCode: "+216", dial: "+216" },
  { code: "TR", iso: "TR", name: "Turkey", dialCode: "+90", dial: "+90" },
  { code: "TM", iso: "TM", name: "Turkmenistan", dialCode: "+993", dial: "+993" },
  { code: "TC", iso: "TC", name: "Turks and Caicos Islands", dialCode: "+1", dial: "+1" },
  { code: "TV", iso: "TV", name: "Tuvalu", dialCode: "+688", dial: "+688" },
  { code: "UG", iso: "UG", name: "Uganda", dialCode: "+256", dial: "+256" },
  { code: "UA", iso: "UA", name: "Ukraine", dialCode: "+380", dial: "+380" },
  { code: "AE", iso: "AE", name: "United Arab Emirates", dialCode: "+971", dial: "+971" },
  { code: "GB", iso: "GB", name: "United Kingdom", dialCode: "+44", dial: "+44" },
  { code: "US", iso: "US", name: "United States", dialCode: "+1", dial: "+1" },
  { code: "UM", iso: "UM", name: "United States Minor Outlying Islands", dialCode: "+1", dial: "+1" },
  { code: "UY", iso: "UY", name: "Uruguay", dialCode: "+598", dial: "+598" },
  { code: "UZ", iso: "UZ", name: "Uzbekistan", dialCode: "+998", dial: "+998" },
  { code: "VU", iso: "VU", name: "Vanuatu", dialCode: "+678", dial: "+678" },
  { code: "VE", iso: "VE", name: "Venezuela", dialCode: "+58", dial: "+58" },
  { code: "VN", iso: "VN", name: "Vietnam", dialCode: "+84", dial: "+84" },
  { code: "VI", iso: "VI", name: "Virgin Islands (U.S.)", dialCode: "+1", dial: "+1" },
  { code: "WF", iso: "WF", name: "Wallis and Futuna", dialCode: "+681", dial: "+681" },
  { code: "EH", iso: "EH", name: "Western Sahara", dialCode: "+212", dial: "+212" },
  { code: "YE", iso: "YE", name: "Yemen", dialCode: "+967", dial: "+967" },
  { code: "ZM", iso: "ZM", name: "Zambia", dialCode: "+260", dial: "+260" },
  { code: "ZW", iso: "ZW", name: "Zimbabwe", dialCode: "+263", dial: "+263" },
];

export function codeToFlag(code) {
  if (!code || typeof code !== "string" || code.length !== 2) return "";
  const upper = code.toUpperCase();
  const A_OFFSET = 0x1f1e6;
  const base = "A".charCodeAt(0);
  const c1 = upper.charCodeAt(0);
  const c2 = upper.charCodeAt(1);
  if (c1 < base || c1 > base + 25 || c2 < base || c2 > base + 25) return "";
  return (
    String.fromCodePoint(c1 - base + A_OFFSET) +
    String.fromCodePoint(c2 - base + A_OFFSET)
  );
}

const BY_CODE = COUNTRIES.reduce((acc, c) => {
  acc[c.code] = c;
  return acc;
}, {});

export function getCountry(code) {
  if (!code || typeof code !== "string") return null;
  return BY_CODE[code.toUpperCase()] || null;
}

// Backward-compat alias used by older callers.
export const findByIso = getCountry;

export default COUNTRIES;
